import { MODE_ONSITE } from "../../constants/constants";
import { AppState } from "../../interfaces/app.interface";
import { UpdateAppStateAction } from "./appActions";
import * as actionTypes from './appActionTypes';


type AppActions = UpdateAppStateAction | { type: string; payload?: any };

const initialState: AppState = {
  selectedMode: MODE_ONSITE,
  companyId: null,
  currentLocation: null,
};

export default function appReducer(state = initialState, action: AppActions): AppState {
  switch (action.type) {
    case actionTypes.UPDATE_APP_STATE:
      return { ...state, ...action.payload }; // only update passed fields
    case actionTypes.FETCH_LOCATION_SUCCESS:
      console.log("🚀 ~ appReducer ~ action.payload:", action.payload)
      return { ...state, currentLocation: action.payload };
    default:
      return state;
  }
}
